import React, {useCallback, useState} from 'react';

interface UseLoadingResult {
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  startLoading: () => void;
  stopLoading: () => void;
}

export const useLoading = (initialLoading = false): UseLoadingResult => {
  const [loading, setLoading] = useState(initialLoading);

  const startLoading = useCallback(() => {
    setLoading(true);
  }, []);

  const stopLoading = useCallback(() => {
    setLoading(false);
  }, []);

  return {
    loading,
    setLoading,
    startLoading,
    stopLoading,
  };
};
